import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import APP_ROUTES from '../../constants/app-routes';

import styles from './styles/signup-promotion.scss';
import history from '../../browser-history';
import UserSignupConnector from '../../containers/user-signup-connector';

class SignupPromotion extends Component {
    render() {
        return !(this.props.user && this.props.user.id) && process.env.REACT_APP_DISABLE_AUTH !== 'true' && (
            <div>
                <div className={styles.promotionContainer}>
                    <div className={styles.signupPromotion}>
                        <p>
                            <span className="hidden-xs">
                                <FormattedMessage id="signup-for" defaultMessage="Sign Up" />
                            </span>
                            <span>
                                <FormattedMessage id="for-the-best-experience" defaultMessage="for the best experience" />
                            </span>
                            <span className="hidden-xs">
                                <FormattedMessage id="in-katapulk" defaultMessage="in the Store" />
                            </span>
                            <Link to={APP_ROUTES.signup} className={`button-highlight font-vegur font-size-medium-small text-uppercase ${styles.buttonHighlight}`}>
                                <FormattedMessage id="signup" defaultMessage="Sign Up" />
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default SignupPromotion;



/** WEBPACK FOOTER **
 ** ./src/components/shared/signup-promotion.jsx
 **/